import { render, staticRenderFns } from "./DispatchException.vue?vue&type=template&id=0387400b&scoped=true"
import script from "./DispatchException.vue?vue&type=script&lang=js"
export * from "./DispatchException.vue?vue&type=script&lang=js"
import style0 from "./DispatchException.vue?vue&type=style&index=0&id=0387400b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387400b",
  null
  
)

export default component.exports